import { TailSpin } from 'react-loader-spinner';

import * as S from './Loader.styles';

type LoaderProps = {
  children: any; // eslint-disable-line
  isLoading: boolean;
  isBtnLoader?: boolean;
};

export function Loader(props: LoaderProps): React.ReactElement {
  const { children, isLoading, isBtnLoader } = { ...props };

  if (isBtnLoader) {
    return (
      <S.Container>
        {isLoading ? (
          <S.WrapperBtn data-testid="loader">
            {children}
            <S.SpinnerWrapper>
              <TailSpin width="15" color="#286090" />
            </S.SpinnerWrapper>
          </S.WrapperBtn>
        ) : (
          children
        )}
      </S.Container>
    );
  }

  return (
    <S.Container>
      {isLoading ? (
        <S.Wrapper data-testid="loader">
          <TailSpin width="100" color="#286090" />
        </S.Wrapper>
      ) : (
        children
      )}
    </S.Container>
  );
}
